require("../sass/main.scss");
import ReactDOM from "react-dom";
import React from "react";
import { Provider } from "mobx-react";
import { ServicePlanContent } from "./components/ServicePlan";
import ServicePlanStore from "./components/ServicePlan/ServicePlanStore";

const providerServicePlanContent = (
  <Provider servicePlanStore={new ServicePlanStore()}>
    <ServicePlanContent />
  </Provider>
);

const servicePlanFormRoot = document.getElementById("servicePlan");
if (servicePlanFormRoot) {
  ReactDOM.render(providerServicePlanContent, servicePlanFormRoot);
}
